import MultiProvinceFilter from "../../Shared/MultiProvinceFilter";
import { PaginatedChristmasBonusQueryVariables } from "@/graphql/__generated__/graphql";

interface Props {
  displayAmount: number;
  handleSubmitClick: (_variables: PaginatedChristmasBonusQueryVariables) => void;
}

/**
 * Christmas Bonus specific province filter configuration
 */
const christmasBonusProvinceConfig = {
  paginationStateKey: "paginatedChristmasBonus" as keyof PaginationState,
  buildQueryVariables: (
    displayAmount: number,
    filters: any,
    provinces: string[] | null
  ): PaginatedChristmasBonusQueryVariables => ({
    first: displayAmount,
    filters: {
      activeFrom: filters.activeFrom || null,
      provinces,
    },
  }),
  extractFilters: (paginationState: any) => paginationState?.filters || {},
};

function ChristmasBonusProvincesDropdown(props: Props) {
  const { displayAmount, handleSubmitClick } = props;

  return (
    <MultiProvinceFilter
      displayAmount={displayAmount}
      handleSubmitClick={handleSubmitClick}
      config={christmasBonusProvinceConfig}
    />
  );
}

export default ChristmasBonusProvincesDropdown;
